<template >
<v-container fluid >
    <v-row class="justify-center align-center ma-2 pa-2">
        <v-card width="40%" elevation="11" class="pa-2 d-flex justify-center primary"><h1 class="textTitle--text">{{$t('sellScreen.screenTitle')}}</h1></v-card>
        </v-row>
    <v-row class="justify-center">
        <v-row class="justify-center align-center">
            <v-col cols="6">
                <v-row class="justify-center align-center">
                    <v-btn @click="chooseclient" class="success font-weight-black black--text text-h4 ma-5 pa-5">{{$t('sellScreen.clientButton')}}</v-btn>
                     <v-chip v-if="selectedclient.name" large class="ma-5 pa-5 quaterny text-h4 primary--text font-weight-black">{{selectedclient.name}}</v-chip>
                     <v-chip v-else large class="ma-5 pa-5 quaterny text-h4 primary--text font-weight-black">{{defaultClient.name}}</v-chip>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row class="justify-center align-center">
                    <v-btn @click="getCart" class="info font-weight-black text-h4 black--text ma-5 pa-5">{{$t('sellScreen.cartButton')}}</v-btn>
                </v-row>
                <v-row class="justify-center align-center">
                    <h1 class="textTitle--text">{{itemcart}}{{$t('sellScreen.cartResume')}}{{totalcart}}</h1>
                </v-row>
            </v-col>
        </v-row>
       
        
    </v-row>
    
    <v-dialog v-model="chooseClientDialog" width="80%">
        <v-card elevation="11" class="ma-2 pa-2 primary">
   <chooseClient @changeclient="setClient($event)"/>
    </v-card>
    </v-dialog>

    <v-dialog v-model="carritoDialog" width="80%">
         <cartlist :selectedprods="prodCartSelection" :client="getClient()" @ventadone="prodCartSelection=[];carritoDialog=false;itemcart=0;totalcart=0" @total="totalcart=$event" @qtyprod="itemcart=$event"/>
    </v-dialog>   
    
    <v-divider></v-divider>
    <v-card elevation="11" class="ma-2 pa-2 primary">
    <v-row >
        <v-col cols="4">
            <prodCats2 @changecat="setCat($event)"/>
        </v-col>
        <v-col cols="8">
             
    <prodSelector2 
    :selectedproducts="selectedproducts"
    @addcart="addToCart($event)"
    />
        </v-col>
    </v-row>
    </v-card>
   <v-dialog :retain-focus='false' width="550px" v-model="errorProdExist">
              <errorMessage @close="errorProdExist=false" :title="'Error'" :message="$t('sellScreen.errorProdExist')" :key="errorKey"/>
            </v-dialog>
            <v-dialog :retain-focus='false' width="550px" v-model="errorInvQty">
              <errorMessage @close="errorInvQty=false" :title="'Error'" :message="$t('sellScreen.errorQtyProd')+prodCurrenttInv" :key="errorKey"/>
            </v-dialog>
</v-container>
</template>

<script>
import chooseClient from "@/components/chooseClient"
import prodCats2 from "@/components/prodCats2"
import prodSelector2 from "@/components/prodSelector2"
import cartlist from "@/components/cartlist"
import errorMessage from '@/components/errorMessage'
//import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    components:{chooseClient,prodCats2,prodSelector2,cartlist,errorMessage},
    data () {
        return {
            catactive:{},
            prodCartSelection:[],
            selectedproducts:[],
            selectedclient:{},
            prodCurrenttInv:0,
            errorKey:0,
            errorProdExist:false,
            errorInvQty:false,
            chooseClientDialog:false,
            chooseClientDialogKey:0,
            carritoDialog:false,
            carritoDialogKey:0,
            totalcart:0,
            itemcart:0,

          }
    },
    computed:{
        defaultClient(){
          var  defaultClient= this.$store.state.clients[0]
          return defaultClient
        },
        ...mapGetters({
        clientsdb:'clientDb',
        productsdb:'prodList',
      })
    },
    methods:{
        getClient(){
            
            if (this.selectedclient.name){
                return this.selectedclient
            }else{
                return this.defaultClient
            }
        },
        getCart(){
            this.carritoDialog=true,
            this.carritoDialogKey+=1
        },
        chooseclient(){
            this.chooseClientDialog=true
            this.chooseClientDialogKey+=1
        },
        addToCart(v){
            var id = 'carItem';
            var prod = v
            this.prodCurrenttInv = prod.CurrenttInv
        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        if(this.prodCartSelection){
            
            id = prod.id;
            var has=0
            if(this.prodCartSelection.length){
            for(var u=0;u<this.prodCartSelection.length;u++){
                if(this.prodCartSelection[u].id==id){ has=1}
            }}

            if(has==1){
                this.errorProdExist=true
                }else{
            if(prod.qty<=prod.currenttInv){
                    this.prodCartSelection.push(
                {id:id,prodid:prod.id,codigo:prod.codigo,name:prod.name,qty:prod.qty,pu:prod.pu,total:prod.qty*prod.pu,currenttInv:prod.currenttInv}
            )
                }else{this.errorInvQty=true}
            
            }
            }else{
            if(prod.qty<=prod.currenttInv){
                    this.prodCartSelection.push(
                {id:id,prodid:prod.id,codigo:prod.codigo,name:prod.name,qty:prod.qty,pu:prod.pu,total:prod.qty*prod.pu,currenttInv:prod.currenttInv}
            )
                }else{this.errorInvQty=true}
            
            }
            this.itemcart+=1
            this.totalcart+=(prod.pu*prod.qty)
            
        },
        setClient(v){
            this.selectedclient=v;
            this.chooseClientDialog=false
        },
        setCat(v){
            this.catactive=v;
            var products=this.productsdb
            this.selectedproducts=[]
            if(products){
                
            for(var i=0;i<products.length;i++){
                
                if(products[i].catid==v.id){
                    
                    this.selectedproducts.push(products[i])
                }
                else{
                    if(products[i].catid.includes(v.id)){
                        
                       this.selectedproducts.push(products[i])}
                    //var parentcatid = products[i].catid.split("-")
                    //if(parentcatid[0]==v.id){
                    
                    //
                //}
                }
            }
            }
        },
    }
}
</script>